import { ComponentPropsWithoutRef, ReactNode } from "react";
import { twMerge } from "tailwind-merge";

interface IDetailTagProps extends ComponentPropsWithoutRef<"span"> {
  /** Optional leading icon (an `<img>` of a local SVG, or an inline icon). */
  icon?: ReactNode;
}

/**
 * Small rounded pill used on the agendamento details page (service type,
 * "Revistoria", time). Colors come from `className` at the call site — neutral
 * by default. For `StatusAgendamentoEnum` use `StatusTagV2`; for the ringed
 * icon-circle shape used on batch/validation screens use `IconPillTag`.
 */
export const DetailTag = ({
  icon,
  className,
  children,
  ...rest
}: IDetailTagProps) => (
  <span
    {...rest}
    className={twMerge(
      "inline-flex items-center gap-1.5 rounded-full border border-solid border-[#e5e5ea] bg-[#fafcfe] px-2.5 py-1 font-['Mulish'] text-xs font-normal whitespace-nowrap text-[#2d2d2d]",
      className,
    )}
  >
    {icon}
    {children}
  </span>
);
